"use client";

import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";

import { COLOR_WHITE } from "~/theme/colors";
import { getFormatMedia } from "~/theme/utils";

import { PRODUCTS_FILTERS_CLASSES } from "./constants";

export const ProductsFiltersContainer = styled(Box)(({ theme }) => {
  const formatMedia = getFormatMedia(theme);
  const { BREAKPOINT_TABLET, BREAKPOINT_DESKTOP } = formatMedia;

  return {
    height: "100%",
    [BREAKPOINT_DESKTOP]: {
      all: "unset",
      width: 255,
      minWidth: 255,
      maxWidth: 255,
    },
    [`& .${PRODUCTS_FILTERS_CLASSES.filterContentWrapper}`]: {
      height: "calc(100% - 56px)",
      overflow: "hidden auto",
      [BREAKPOINT_DESKTOP]: {
        height: "100%",
        overflow: "hidden",
      },
    },
    [`& .${PRODUCTS_FILTERS_CLASSES.filterTopBar}`]: {
      display: "none",
      [BREAKPOINT_DESKTOP]: {
        height: 56,
        alignItems: "center",
        display: "flex",
        paddingLeft: theme.spacing(2),
      },
    },
    [`& .${PRODUCTS_FILTERS_CLASSES.filterTopBarMobileSticky}`]: {
      position: "sticky",
      top: 0,
      left: 0,
      zIndex: 2,
      background: COLOR_WHITE,
      [BREAKPOINT_DESKTOP]: {
        display: "none",
      },
    },
    [`& .${PRODUCTS_FILTERS_CLASSES.filterTopBarMobile}`]: {
      height: 56,
      alignItems: "center",
      display: "flex",
      justifyContent: "space-between",
      padding: theme.spacing(0, 3),
    },
    [`& .${PRODUCTS_FILTERS_CLASSES.filterBtnMobile}`]: {
      height: 56,
      alignItems: "center",
      display: "flex",
      "& > button": {
        padding: 0,
        marginRight: theme.spacing(1),
      },
    },
    [`& .${PRODUCTS_FILTERS_CLASSES.filterTitle}`]: {
      marginLeft: theme.spacing(1),
    },
    [`& .${PRODUCTS_FILTERS_CLASSES.showButton}`]: {
      width: "100%",
      position: "fixed",
      bottom: 0,
      [BREAKPOINT_TABLET]: {
        width: 400,
      },
      [BREAKPOINT_DESKTOP]: {
        display: "none",
      },
    },
  };
});

export const ProductsFiltersMobileDrawer = styled(Drawer)(({ theme }) => {
  const formatMedia = getFormatMedia(theme);
  const { BREAKPOINT_TABLET, BREAKPOINT_DESKTOP } = formatMedia;

  return {
    [`& .${PRODUCTS_FILTERS_CLASSES.drawer}`]: {
      width: "100%",
      [BREAKPOINT_TABLET]: {
        width: 400,
      },
      [BREAKPOINT_DESKTOP]: {
        display: "none",
      },
    },
  };
});
